import { useMemo } from "react";
import { useSeo } from "@/hooks/useSeo";
import { movies } from "@/mocks/movies";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuick from "@/pages/home/components/CategoryQuick";
import LatestGrid from "@/pages/home/components/LatestGrid";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  useSeo({
    title: "《出轨的妻子》hd影视资源及剧情介绍",
    description:
      "《出轨的妻子》hd网站提供电影相关的高清影视资源、剧情介绍和影评，涵盖电影详情及观看指南，满足影迷查询需求。",
    keywords: "出轨的妻子,出轨的妻子电影,高清电影,影视资源,剧情介绍",
  });

  const featured = useMemo(() => movies.filter((m) => m.featured), []);
  const latest = useMemo(() => movies.slice(0, 8), []);

  return (
    <>
      <HeroCarousel slides={featured} />
      <CategoryQuick />
      <LatestGrid movies={latest} />
      <SiteIntro />
    </>
  );
}